<template>
    <AppModal :name="name"
              :beforeOpen="beforeOpen"
              :clickToClose="!isForceSetup"
              :beforeClose="beforeClose">
        <template slot="header">
            {{ isForceSetup ? 'Two-factor Required' : 'Setup Two-factor' }}
        </template>
        <template slot="content">
            <p class="mb-0">
                <template v-if="isForceSetup">
                    Access to this team requires you to enable two-factor authentication
                </template>
                <template v-else>
                    Secure your account with two-factor authentication
                </template>
            </p>

            <div class="row justify-content-center" style="height: 180px">
                <img v-if="qrCodeImg" :src="qrCodeImg" alt="QR Code" class="h-100" style="object-fit: cover">
                <div v-else class="pt-5">QR Code is not fetched</div>
            </div>
            <p>
                Scan the above code with your preferred two-factor authentication app <br> and enter the code below.
            </p>

            <div class="row justify-content-center">
                <div class="col-8">
                    <TwoFactorCode @input="onCodeInput"/>
                </div>
            </div>

            <p v-if="isVerifyError" class="text-danger mt-2">
                Verification code is incorrect
            </p>
        </template>
        <template slot="actions">
            <div class="row justify-content-end mx-0 mt-3">
                <div v-if="isForceSetup && getTeams.length > 1" class="col-5 text-left">
                    <label>Select another team</label>
                    <multiselect
                        :value="activeTeam"
                        @select="selectActiveTeam"
                        :options="getTeams"
                        trackBy="uuid"
                        label="name"
                        placeholder="Select a team"/>
                </div>
                <div class="text-right" :class="isForceSetup && getTeams.length > 1 ? 'col-7' : 'col'">
                    <button v-if="!isForceSetup" @click="cancel" class="btn btn-link">Cancel</button>
                    <button v-loading.btn="isLoading"
                            @click="enableTwoFactor"
                            style="width: 200px"
                            class="btn btn-primary">
                        Enable two-factor
                    </button>
                </div>
            </div>
        </template>
    </AppModal>
</template>

<script>
import axios from 'axios'
import TwoFactorCode from '../../../components/TwoFactorCode'
import {AUTH_FORCE_2FA_SETUP, AUTH_SET_ACTIVE_TEAM, USER_UPDATE} from '../../../store/mutations'
import {mapActions, mapGetters, mapMutations} from 'vuex'

export default {
    name: 'SetupTwoFactor',
    props: {
        name: {type: String, required: true}
    },
    components: {TwoFactorCode},
    data() {
        return {
            qrCode: '',
            qrCodeImg: '',

            isForceSetup: false,
            isLoading: false,
            isVerifyError: false
        }
    },
    computed: {
        ...mapGetters([
            'getUser',
            'activeTeam',
            'getTeams'
        ])
    },
    methods: {
        ...mapMutations({
            setActiveTeam: AUTH_SET_ACTIVE_TEAM
        }),

        ...mapActions({
            force2faSetup: AUTH_FORCE_2FA_SETUP
        }),

        async selectActiveTeam(team) {
            this.setActiveTeam(team)
            await this.$modal.hide(this.name)
            await this.$router.push({name: this.$route.name, params: {...this.$route.params, team: team.uuid}})
            if (this.isForceSetup) {
                this.force2faSetup()
            }
        },

        beforeOpen({params}) {
            if (params && params.qrCodeImg) {
                this.qrCodeImg = params.qrCodeImg
                this.isForceSetup = !!params.force
            }
        },

        beforeClose() {
            this.isVerifyError = false
        },

        onCodeInput(code) {
            this.qrCode = code
        },

        enableTwoFactor() {
            this.isLoading = true
            axios.post(`users/2fa/verify/${this.qrCode}`)
                .then(() => {
                    this.$store.commit(USER_UPDATE, {hasTwoFactor: true})
                    this.isLoading = false
                    this.$modal.hide(this.name)
                    this.$modal.show('successful-two-factor-enabling')
                    this.$bus.$emit('2FA_SETUP_COMPLETE')
                })
                .catch(err => {
                    if (err.response.status === 400) {
                        this.isVerifyError = true
                    } else {
                        this.$snackbar.show({type: 'ERROR', text: 'Unknown error'})
                    }
                    this.$bus.$emit('CLEAR_2FA_CODE')
                    this.isLoading = false
                })
        },

        cancel() {
            this.$bus.$emit('2FA_SETUP_CANCEL')
            this.$modal.hide(this.name)
        }
    },
    watch: {
        qrCode(val) {
            this.qrCode = val
            if (val.length === 6) {
                this.enableTwoFactor()
            }
        }
    }
}
</script>
